var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"status",style:({ backgroundColor: _vm.rowData.setup['color'] }),attrs:{"title":'Setup Grade: ' + _vm.rowData.setup['name']}}),_vm._v(" "),_c('a',{staticClass:"go",attrs:{"href":_vm.rowData.contentSeoUrl,"title":_vm.linkTitle}},[_vm._v(_vm._s(_vm.rowData.sourceName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }